/* ============================================================================
   RK Warenkorb auffrischen

   Zwei Dinge blieben im Warenkorb nach einer Mengenänderung stehen:

   · Die Gesamtsumme. Das Theme lädt den Warenkorbfuß nach einer Änderung
     nicht neu — geprüft mit abgeschaltetem Skript: die Summe blieb dauerhaft
     auf dem alten Stand, bis jemand die Seite neu lud.
   · Die Rabattstaffel. Sie ist eine eigene Section und stand nicht auf der
     Liste der Abschnitte, die das Theme aktualisiert.

   Dieses Skript holt beide Abschnitte frisch vom Server und prüft danach
   gegen /cart.js nach, ob die angezeigte Summe wirklich stimmt. Tut sie es
   nicht, versucht es erneut — feste Wartezeiten reichen nicht, weil das
   Theme bei einer Mengenänderung mehrere Anfragen hintereinander schickt.

   Abschnitte melden sich mit data-rk-auffrischen="{{ section.id }}" an.
   ========================================================================= */
(function () {
  'use strict';

  var ANLAEUFE = 4;
  var warten = null;
  var laeuft = false;

  function ziele() {
    return [].slice.call(document.querySelectorAll('[data-rk-auffrischen]'));
  }

  function summeImDom() {
    // Bewusst innerhalb des Warenkorbfußes: Die Warenkorb-Schublade bringt
    // dieselbe Klasse mit und steht im Quelltext davor — ein einfacher
    // Selektor misst sonst die versteckte Schublade statt der Seite.
    var e = document.querySelector('.cart__footer .totals__total-value');
    if (!e) return null;
    var z = e.textContent.replace(/[^0-9,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.');
    return parseFloat(z);
  }

  function hole(ids) {
    // Ohne Accept-Header: Auf /cart liefert application/json die
    // Warenkorb-API statt der gerenderten Abschnitte.
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (a) { return a.ok ? a.json() : null; });
  }

  function einsetzen(daten) {
    ziele().forEach(function (ziel) {
      var html = daten[ziel.getAttribute('data-rk-auffrischen')];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var quelle = doc.querySelector('[data-rk-auffrischen]');
      if (quelle) ziel.innerHTML = quelle.innerHTML;
    });
  }

  function durchgang(rest) {
    var liste = ziele();
    if (!liste.length) { laeuft = false; return; }

    var ids = [];
    liste.forEach(function (z) {
      var id = z.getAttribute('data-rk-auffrischen');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });

    Promise.all([hole(ids), fetch('/cart.js').then(function (a) { return a.json(); })])
      .then(function (paar) {
        var daten = paar[0], korb = paar[1];
        if (!daten) { laeuft = false; return; }
        einsetzen(daten);

        // Stimmt die angezeigte Summe zur Wahrheit aus /cart.js?
        var soll = korb.total_price / 100;
        var ist = summeImDom();
        var passt = ist === null || Math.abs(ist - soll) < 0.01;

        if (!passt && rest > 0) {
          setTimeout(function () { durchgang(rest - 1); }, 600);
        } else {
          laeuft = false;
        }
      })
      .catch(function () {
        // Scheitert das Auffrischen, bleibt der alte Stand stehen — besser
        // als eine halb ersetzte Seite. Ein Neuladen zeigt die Wahrheit.
        laeuft = false;
      });
  }

  function anstossen() {
    clearTimeout(warten);
    warten = setTimeout(function () {
      if (laeuft) return;
      laeuft = true;
      durchgang(ANLAEUFE);
    }, 400);
  }

  /* Das Set-Fenster meldet sich selbst, wenn es mehrere Teile auf einmal
     hineingelegt hat — sonst stünden Versandleiste und Rabattstaffel noch
     auf dem alten Stand, während der Warenkorb schon voll ist. */
  document.addEventListener('rk:warenkorb-geaendert', anstossen);

  // Das Theme meldet Warenkorb-Änderungen über sein eigenes Pub/Sub.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, anstossen);
  }

  // Zusätzlich an der Quelle mithören: Nicht jede App nutzt das Pub/Sub,
  // und die Mengenwahl spricht direkt mit /cart/change.
  var urspruenglich = window.fetch;
  window.fetch = function () {
    var ziel = arguments[0];
    var pfad = typeof ziel === 'string' ? ziel : (ziel && ziel.url) || '';
    var antwort = urspruenglich.apply(this, arguments);
    if (/\/cart\/(change|add|update|clear)/.test(pfad)) {
      antwort.then(anstossen).catch(function () {});
    }
    return antwort;
  };
})();
